import script from "./CollectionCommunityActivityWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCommunityActivityWallet.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCommunityActivityWallet.vue?vue&type=style&index=0&id=9826f906&lang=scss"

const __exports__ = script;

export default __exports__